// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { GLYPH_VIEWBOX, GLYPH_STROKE } from './glyph';
import type { SymbolGlyphProps } from './glyph';
import { Leads } from './Leads';

/**
 * Transformer — two overlapping circles, the IEEE 315 / IEC 60617 two-winding
 * one-line form.
 *
 * Drawn on the vertical because the run through a transformer is a vertical
 * drop on this drawing: primary on top, secondary below. GA-10 publishes nine
 * of these between the utility feeders and the input boards; the mock has none.
 */
export const TransformerSymbol = ({ size = 18, leads }: SymbolGlyphProps) => (
  <svg
    className="sld-glyph"
    width={size}
    height={size}
    viewBox={GLYPH_VIEWBOX}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="9" r="5.5" stroke="currentColor" strokeWidth={GLYPH_STROKE} />
    <circle cx="12" cy="15" r="5.5" stroke="currentColor" strokeWidth={GLYPH_STROKE} />
    <Leads top={3.5} bottom={20.5} leads={leads} />
  </svg>
);
